import * as React from 'react';
import { difference, flow, get } from 'lodash';
import { FieldArray, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { renderProductDefinition } from '../../../../Helpers';
import { Button, Col, Form, Grid, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import Loading from '../../../../../../../../components/Loading';
import { IBrandingActions, II18nMessages } from '../../../../../../../../services/branding/models';
import { withJob } from 'react-jobs';
import Destination from '../../../../../../../Quote/scenes/TripDetails/components/Destination';
import StateCities from '../../../../../../../Quote/scenes/TripDetails/components/StateCities';
import { MTACardHeader } from '../Components/MTACardHeader';
import { MTAButtons } from '../../../MTAButtons';
import { Link } from 'react-router-dom';
import * as Commonmark from 'react-commonmark';
import { FaInfoCircle, FaSpinner } from 'react-icons/fa';

interface MTAChangeDestinationFormProps extends InjectedFormProps<any> {
  mta: IMtaState;
  i18n: II18nMessages;
  formValues: any;
  selectedPolicy: any;
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions
  };

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

class MTAChangeDestinationForm extends React.Component<MTAChangeDestinationFormProps, any> {

  constructor(props) {
    super(props);
    const { dispatch, change } = props;
    dispatch(change('page', PageForm.MTA_CHANGE_DESTINATION));
    window.scrollTo(0, 0);
  }

  public handleSubmit = () => {
    const { actions } = this.props;

    Promise.all([
      actions.mta.calculateMtaPremiums(),
    ]).then(() => {
      actions.mta.addEndorsements();
      actions.mta.handleMTASubmit();
    });
  }

  render() {
    const { mta, handleSubmit, submitting, submitFailed, valid, i18n, actions, formValues } = this.props;
    const product = actions.branding.getProduct();
    const renderDefinition = renderProductDefinition(product);
    const isLoading = mta.isLoading;
    const destinationsValue = get(formValues, 'metadata.destinations', []);
    const stateCitiesValue = get(formValues, 'metadata.stateCities',  get(formValues, 'metadata.state_cities', []));

    const popoverClickRootClose = (
      <Popover id="popover-trigger-click-root-close">
        <Commonmark source={product.metadata.definitions.destinations}
        />
      </Popover>
    );

    const continueButton = (
      <Button
        bsStyle="primary"
        type="submit"
        className="secondary-button pull-right"
        disabled={submitting || (submitFailed && !valid || !valid || isLoading)}>
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        APPLY CHANGES
      </Button>
    );

    const goBackButton = (
      <Link to="/account/summary">
        <Button
          bsStyle={'primary'}
          className={'secondary-button'}>
          GO BACK
        </Button>
      </Link>
    )

    const subtext = (
      <div>Where are you travelling to?
        <span>
          <OverlayTrigger
            trigger="click"
            rootClose={true}
            placement="bottom"
            overlay={popoverClickRootClose}
          ><FaInfoCircle className="info-btn dark_blue"/>
          </OverlayTrigger>
        </span>
      </div>
    )

    return (
      <>
        <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
          <div className="admiral-card" style={{ marginTop: '20px' }}>
            <MTACardHeader
              text={'Update your destination below'}
              subtext={subtext}
              icon={'countries'}
              border={true}
            />
            <div className="body">
              <Grid fluid={true}>
                <Row>
                  <Col sm={6} className={'full-width-xs'}>
                    <div>
                      <FieldArray
                        name="data.attributes.metadata.destinations"
                        i18n={i18n}
                        destinations={mta.destinations}
                        component={Destination}
                        placeholder={'Please type or select your desired country'}
                        destinationsValue={destinationsValue}
                        loading={isLoading}
                        mta={true}
                      />
                      <FieldArray
                        name="data.attributes.metadata.state_cities"
                        i18n={i18n}
                        stateCities={mta.stateCities}
                        component={StateCities}
                        placeholder={'Please type or select your desired country'}
                        stateCitiesValue={stateCitiesValue}
                        destinationsValue={destinationsValue}
                        renderDefinition={renderDefinition}
                        loadin={isLoading}
                        mta={true}
                      />
                    </div>
                  </Col>
                </Row>
              </Grid>
            </div>
          </div>
          <div className={'mt-30'}/>
          <MTAButtons button1={goBackButton} button2={continueButton}/>
        </Form>
      </>
    )
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: any,
      dispatch,
      props: MTAChangeDestinationFormProps,
    ) => {
      if (!previousValues) {
        previousValues = values;
        return;
      }
      const destinations = get(values, 'data.attributes.metadata.destinations', []);
      const previousDestinations = get(previousValues, 'data.attributes.metadata.destinations', []);

      let recalculateScore = false;

      if (difference(previousDestinations, destinations).length > 0) {
        recalculateScore = true;
      }
      const filtered = destinations.filter(destinations => destinations);

      if (recalculateScore && filtered.length > 0) {
        props.actions.mta.recalculateScreening(destinations, 'single');
      }

      previousValues = values;
    },
  }),
  withJob({
    work: (props: MTAChangeDestinationFormProps) => {
      const promises = [];

      if (props.mta.destinations.length === 0) {
        promises.push(props.actions.mta.loadDestinations());
      }

      if (props.mta.stateCities.length === 0) {
        promises.push(props.actions.mta.loadStateCities());
      }

      return Promise.all(promises);
    },
    LoadingComponent: () => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(
        state,
        'data.attributes',
      );
      return {
        mta: state.mta,
        selectedPolicy: state.mta.selectedPolicy,
        i18n: state.branding.i18n,
        formValues: values,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(MTAChangeDestinationForm);
